import clsx from 'clsx';
import { RotatingLines } from 'react-loader-spinner';
import { useEffect, useRef } from 'react';

interface Props {
  label?: string;
  loading?: boolean;
  disabled?: boolean;
  inputStyle?: string;
  icon?: any;
  onClick?: (e?: any) => void;
  id: string;
  paymentBtn?: boolean;
  disableListener?: boolean;
  ariaLabel?: string;
}

const SubmitButton: React.FC<Props> = ({
  label,
  loading,
  disabled,
  inputStyle,
  icon,
  onClick,
  id,
  paymentBtn,
  disableListener,
  ariaLabel,
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const normalizeInputStyle = clsx('primaryButton w-full', paymentBtn && 'w-full md:w-max gap-3', inputStyle);

  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && !buttonRef.current?.disabled) {
      buttonRef.current?.click();
    }
  };

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    onClick?.(event);
  };

  useEffect(() => {
    if (disableListener) return;
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [disableListener]);

  return (
    <button
      id={id}
      ref={buttonRef}
      data-testid={id}
      aria-label={ariaLabel || id}
      className={normalizeInputStyle}
      disabled={disabled}
      onClick={e => handleClick(e)}
    >
      {paymentBtn && label}
      {loading ? (
        <RotatingLines strokeColor='white' strokeWidth='2' animationDuration='0.75' width='24' visible={true} />
      ) : (
        <>
          {!paymentBtn && label}
          {icon}
        </>
      )}
    </button>
  );
};

export default SubmitButton;
